// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-customer .create-customer-actions {\n  padding: 20px 0px;\n  text-align: right;\n}\n.create-customer .create-customer-actions a {\n  margin-right: 20px;\n}\n.create-customer .ui.images {\n  text-align: right;\n}\n.create-customer .ui.images .ui.image.image-upload {\n  margin-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
